/*
  This hook checks if we're on a desktop or on a mobile device and checks the orientation of the device.
  If we're on mobile it returns true
 */
import { useIsWideLayout } from '@hooks/useMediaQuery.ts'

function useShouldRotate() {
  return !useIsWideLayout()
}

export default useShouldRotate